__turbopack_context__.v({
  "banner": "W7aiPq_banner",
  "icon": "W7aiPq_icon",
  "note": "W7aiPq_note",
  "text": "W7aiPq_text",
});
